import React, { useState } from 'react'

export interface BankMeta {
  abbr: string
  bg: string
  text: string
  logo?: string
}

export const BANK_META: Record<string, BankMeta> = {
  'ธนาคารกสิกรไทย':         { abbr: 'K',    bg: '#138f2d', text: '#fff', logo: '/banks/KBANK.png' },
  'ธนาคารไทยพาณิชย์':       { abbr: 'SCB',  bg: '#4e2683', text: '#fff', logo: '/banks/SCB.png' },
  'ธนาคารกรุงไทย':          { abbr: 'KTB',  bg: '#00529b', text: '#fff', logo: '/banks/KTB.png' },
  'ธนาคารกรุงเทพ':          { abbr: 'BBL',  bg: '#1a3f7a', text: '#fff', logo: '/banks/BBL.png' },
  'ธนาคารกรุงศรีอยุธยา':    { abbr: 'BAY',  bg: '#ffd400', text: '#c8102e', logo: '/banks/BAY.png' },
  'ทหารไทยธนชาต':           { abbr: 'TTB',  bg: '#00a6ce', text: '#fff', logo: '/banks/TTB.png' },
  'ธนาคารออมสิน':           { abbr: 'GSB',  bg: '#702082', text: '#fff', logo: '/banks/GSB.png' },
  'อาคารสงเคราะห์':         { abbr: 'GHB',  bg: '#f47920', text: '#fff', logo: '/banks/GHB.png' },
  'ธนาคารทิสโก้':           { abbr: 'TISCO', bg: '#004b87', text: '#fff', logo: '/banks/TISCO.png' },
  'ธนาคารยูโอบี':           { abbr: 'UOB',  bg: '#003087', text: '#fff', logo: '/banks/UOB.png' },
  'ธนาคารแลนด์แอนด์เฮ้าส์': { abbr: 'LH',   bg: '#e31837', text: '#fff', logo: '/banks/LHB.png' },
  'ธนาคารเกียรตินาคินภัทร':  { abbr: 'KKP',  bg: '#003865', text: '#fff', logo: '/banks/KKP.png' },
  'ธนาคารซีไอเอ็มบีไทย':    { abbr: 'CIMB', bg: '#c8102e', text: '#fff', logo: '/banks/CIMB.png' },
  'ธนาคารอิสลามแห่งประเทศไทย': { abbr: 'IB', bg: '#006940', text: '#fff', logo: '/banks/IBANK.png' },
  'ธนาคารไอซีบีซี':         { abbr: 'ICBC', bg: '#d4161c', text: '#fff', logo: '/banks/ICBC.png' },
  'ธนาคารซิตี้แบงก์':       { abbr: 'CITI', bg: '#003b8e', text: '#fff', logo: '/banks/CITI.png' },
  'ธนาคารเอชเอสบีซี':       { abbr: 'HSBC', bg: '#db0011', text: '#fff', logo: '/banks/HSBC.png' },
  'ธนาคารทีซีอาร์บี':       { abbr: 'TCRB', bg: '#002d72', text: '#fff', logo: '/banks/TCRB.png' },
  'ธ.ก.ส.':                  { abbr: 'BAAC', bg: '#006b3f', text: '#fff', logo: '/banks/BAAC.png' },
  'พร้อมเพย์':               { abbr: 'PP',   bg: '#003b8e', text: '#fff', logo: '/banks/PromptPay.png' },
  'ทรูมันนี่':               { abbr: 'TM',   bg: '#ff0000', text: '#fff', logo: '/banks/TrueMoney.png' },
}

interface BankLogoProps {
  bankName: string
  fallbackIcon?: string
  size?: number
  className?: string
}

const BankLogo: React.FC<BankLogoProps> = ({ bankName, fallbackIcon, size = 32, className = '' }) => {
  const [imgFailed, setImgFailed] = useState(false)
  const meta = BANK_META[bankName]
  const logoSize = size
  const r = Math.round(size * 0.2)

  if (meta?.logo && !imgFailed) {
    return (
      <div
        className={`overflow-hidden bg-white flex items-center justify-center shrink-0 ${className}`}
        style={{ width: logoSize, height: logoSize, borderRadius: r }}
      >
        <img
          src={meta.logo}
          alt={bankName}
          className="w-full h-full object-contain p-0.5"
          onError={() => setImgFailed(true)}
        />
      </div>
    )
  }

  if (meta) {
    const fontSize = Math.round(logoSize * 0.32)

    return (
      <div
        className={`flex items-center justify-center font-bold select-none shrink-0 ${className}`}
        style={{ width: logoSize, height: logoSize, borderRadius: r, background: meta.bg, color: meta.text, fontSize, letterSpacing: '-0.02em' }}
      >
        {meta.abbr}
      </div>
    )
  }

  return (
    <span
      className={`flex items-center justify-center text-xl leading-none ${className}`}
      style={{ width: size, height: size }}
    >
      {fallbackIcon ?? '🏦'}
    </span>
  )
}

export default BankLogo
